import * as moment from "moment";

const Highchart = {
    xssettings(title = "", plotBands, max) {
      return {
        chart: {
            height: 200,
            width: 400,
            type: 'line',
            boostThreshold: 1,
            turboThreshold: 0,
            animation: true,
        },
        title: {
            text: ''
        },
        subtitle: {
            text: title
        },
        xAxis: {
            
            type: 'datetime', 
            labels: {
                rotation: -45,
                formatter: function () {                
                    return moment(new Date(this.value)).format('HH:mm');
                },
                style:{
                    fontSize: "8px"
                }
            }
        },
        yAxis: {
            min:0,
            allowDecimals: true,
            plotBands: plotBands 
            
        },
        legend: {
            enabled:false,
        }, 
        plotOptions: {
            series: {
                color: '#000000'
            }
        },
        series: [],
        exporting: {
            enabled: false
        }
      } 
    }   
  }
  
  export default Highchart;